import * as React from 'react';
import { ContentPanel } from '@enginuity-apps-ui-components/atoms/content-panel/content-panel';
import PaperPlaneSVG from './images/PaperPlane';

export type ICheckEmailProps = {
  email?: string;
  fromUri: string;
};

export const CheckEmail: React.FunctionComponent<ICheckEmailProps> = ({ email, children, fromUri }) => {
  return (
    <div className="container  ">
      <div className="row md-spacer-80 spacer-32">
        <div className="col-lg-8 offset-lg-2">
          <ContentPanel>
            <div className="message-panel__padding">
              <div className="row spacer-32">
                <div className="col-12">
                  {PaperPlaneSVG}
                </div>
              </div>
              <div className="row spacer-16">
                <div className="col-12">
                  <h2>Check your inbox</h2>
                </div>
              </div>
              <div className="row spacer-16">
                <div className="col-12">
                  {children}
                </div>
              </div>
              {email && (
                <div className="row spacer-80">
                  <div className="col-12">
                    <p>The email was sent to <span className="email-address">{email}</span></p>
                  </div>
                </div>
              )}
              <div className="row spacer-16">
                <div className="col-12">
                  <div className="activation-panel_footer">Not recieved your email?<br />Remember to check your junk folder</div>
                </div>
              </div>
            </div>
          </ContentPanel>
        </div>
      </div>
      <div className="row spacer-16">
        <div className="col-lg-8 offset-lg-2">
          <a href={`/signin?fromURI=${fromUri}`} className="activation-panel_footer">&lt;&nbsp;Back to sign in</a>
        </div>
      </div>
    </div >
  );
}

export default CheckEmail;
